<template lang="html">
  <div class="floorplan-info">
    <!-- Name -->
    <div class="floorplan-name mt-3 mb-1 d-flex justify-content-center">
      <floorplan-favourite-toggle
      :floorplan="floorplan" />
    </div>

    <div class="beds">
      <!-- Beds + Baths -->
      <span class="floorplan-info-beds">
        <span v-if="floorplan.beds > 0">
          <span class="floorplan-info-dynamic">{{ floorplan.beds }}</span>
          <span>
            <span> b</span>
          </span>
          <span v-if="floorplan.dens > 0">+ den</span>
        </span>
        <span v-else class="floorplan-info-dynamic">studio</span>
      </span>
      <span class="px-1">.</span>
      <span class="baths">
        <span class="floorplan-info-dynamic">{{ floorplan.baths }}</span>
        <span> bath<span v-if="floorplan.baths > 1">s</span></span>
      </span>
    </div>

    <div class="sizes">
      <!-- Sizes -->
      <span>
        <!-- Interior -->
        <span>
          <span>Interior </span>
          <span class="floorplan-info-dynamic">{{ floorplan.interior }} sqft</span>
        </span>
        <!-- Exterior -->
        <span v-if="floorplan.exterior > 0">
          <span class="px-1">&nbsp;</span>
          <span class="pl-1">Exterior</span>
          <span class="floorplan-info-dynamic">{{ floorplan.exterior }} sqft</span>
        </span>
      </span>
      <span class="px-1">&nbsp;</span>
      <!-- Exposure -->
      <span>
        <span>Exposure </span>
        <span class="floorplan-info-dynamic">{{ floorplan.exposure.join(', ').toUpperCase() }}</span>
      </span>
    </div>
  </div>
</template>

<script>
import AnalyticsTracking from '@/analytics/tracking';
import FloorplanFavouriteToggleComponent from '@/components/Floorplan/FloorplanFavouriteToggle';

export default {
  name: 'floorplan-info',
  props: {
    floorplan: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      viewTimeout: null
    };
  },
  methods: {
    viewedFloorplan() {
      this.viewTimeout = setTimeout(() => {
        AnalyticsTracking.viewedFloorplan(this.floorplan);
      }, 5000, this);
    }
  },
  mounted() {
    this.viewedFloorplan();
  },
  updated() {
    this.viewedFloorplan();
  },
  beforeDestroy() {
    clearTimeout(this.viewTimeout);
  },
  components: {
    'floorplan-favourite-toggle': FloorplanFavouriteToggleComponent
  }
};
</script>

<style lang="scss" scoped>
.floorplan-info, .btn-view {
  font-size: 0.8rem;
}

.floorplan-name {
  font-size: 1.4rem;
}

.floorplan-info-dynamic {
  color: var(--text-dark);
  font-size: 1.2rem;
  font-family: Scandia-Regular, sans-serif;
}

.beds {
  color: black;
  font-family: Scandia-Medium;
  font-size: 1.1rem;

  .floorplan-info-dynamic {
    color: black;
    font-family: Scandia-Bold;
  }
}

.sizes {
  color: var(--text);
  font-size: 1rem;

  .floorplan-info-dynamic {
    font-size: 1rem;
    font-family: Scandia-Medium;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Floorplan/FloorplanInfo.vue